/* eslint-disable jsx-a11y/anchor-is-valid */
import {Link} from 'react-router-dom'
import {ROLE_ADMINISTRATOR, ROLE_ROOT} from '../../../../app/common/Utils'
import {useAuth} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import {Languages} from '../header-menus/Languages'
import {useIntl} from 'react-intl'

const UserMenu = () => {
  const intl = useIntl()
  const {currentUser, logout} = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      {/* begin::Menu item */}
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          {/* begin::Avatar */}
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>
          {/* end::Avatar */}

          {/* begin::Username */}
          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.firstName} {currentUser?.lastName}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
          </div>
          {/* end::Username */}
        </div>
      </div>
      {/* end::Menu item */}

      {/* begin::Menu separator */}
      <div className='separator my-2'></div>
      {/* end::Menu separator */}

      {/* begin::Menu item */}
      {currentUser?.role === ROLE_ADMINISTRATOR || currentUser?.role === ROLE_ROOT ? (
        <div className='menu-item px-5'>
          <Link to={'/pages/userpaginate'} className='menu-link px-5'>
            {intl.formatMessage({id: 'MENU.USERS'})}
          </Link>
        </div>
      ) : (
        <></>
      )}

      {/* end::Menu item */}

      {/* begin::Menu item */}
      <div className='menu-item px-5'>
        <Link to={'/pages/userprofile'} className='menu-link px-5'>
          {intl.formatMessage({id: 'MENU.MYPROFILE'})}
        </Link>
      </div>
      {/* end::Menu item */}

      {/* begin::Menu separator */}
      <div className='separator my-2'> </div>
      {/* end::Menu separator */}

      <Languages languageMenuPlacement='right-end' />

      {/* begin::Menu item */}
      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {intl.formatMessage({id: 'MENU.LOGOUT'})}
        </a>
      </div>
    </div>
  )
}

export {UserMenu}
